import type { IProduct } from '../models/product';
import type { ISkuItem, ISkuItemCharacteristic } from './product-to-sku-list';
import type { Product } from '../models/product-legacy';
import { KOPECKS_IN_RUB } from '@/shared/helpers/business/constant-variables';
import type { IPhoto, ISkuPhotoItemCharacteristic } from '../models/slider';
type Photo = Product.Photo;
import { getCurrentSkuPhoto } from '../business/getCurrentSkuPhoto';

type ICartItem = Product.CartItem;

/**
 * Функция маппит выбранный SKU и продукт в объект из списка корзины.
 * @param {IProduct} product - Выбранный продукт.
 * @param {ISkuItem} currentSku - Выбранная SKU. Не уверен, что этот параметр нужен, перенес старый код
 * @param {number} amount - количество добавляемых объектов.
 * @return {Product.ListItem} Объект корзины.
 */
export function mapCartItem(product: IProduct, currentSku: ISkuItem, amount = 1): ICartItem {
  const characteristics = mapCharacteristics(currentSku.characteristics) || {};

  return {
    id: product.id || 0,
    amount,
    categoryId: product.category.title,
    category: product.category,
    amountAvailable: currentSku.availableAmount,
    fullPrice: +(currentSku.fullPrice / KOPECKS_IN_RUB).toFixed(2),
    purchasePrice: +(currentSku.purchasePrice / KOPECKS_IN_RUB).toFixed(2),
    // charityCommission: Math.round((currentSku.charityProfit || 0 * 100) / currentSku.purchasePrice),
    skuId: currentSku.id || 0,
    rating: product.rating,
    seller: product.seller,
    title: product.title,
    isEco: product.isEco,
    isSelected: true,
    offer: currentSku.offer,
    purchasePriceDiscounted: currentSku.purchasePrice - (product.comboDiscountPrice || 0),
    vat: currentSku.vat,
    photo: mapSkuPhoto(product, currentSku),
    characteristics,
    items: [
      {
        id: product.id || 0,
        title: product.title,
        amount: 1,
        amountAvailable: currentSku.availableAmount,
        fullPrice: currentSku.fullPrice,
        purchasePrice: currentSku.purchasePrice,
        skuId: currentSku.id || 0,
        isEco: product.isEco,
        purchasePriceDiscounted: currentSku.purchasePrice - (product.comboDiscountPrice || 0),
        offer: currentSku.offer,
        characteristics,
        category: product.category,
        seller: product.seller,
        vat: currentSku.vat,
      },
    ],
  };
}

function mapCharacteristics(chars: ISkuItemCharacteristic[]): Record<string, string> {
  return chars.reduce((sum, char) => ({ ...sum, [char.title]: char.value.text }), {});
}

function mapSkuPhoto(product: IProduct, currentSku: ISkuItem): Photo {
  const photo: IPhoto | undefined = getCurrentSkuPhoto(currentSku, product.photos);

  return {
    photo: {
      240: {
        low: photo?.low || '',
        high: photo?.high || '',
      },
    },
    photoKey: photo?.photoKey || '',
  };
}
